import { render, staticRenderFns } from "./LearningPlan.vue?vue&type=template&id=642222ab&scoped=true&lang=pug&"
import script from "./LearningPlan.vue?vue&type=script&lang=ts&"
export * from "./LearningPlan.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPlan.vue?vue&type=style&index=0&id=642222ab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642222ab",
  null
  
)

export default component.exports